(function () {
  if(document.body.id !== 'products') return false
  setSlider()

  function setSlider() {
    var slider = document.querySelector('.js-product-slider')
    if(!slider) return false
    var main = slider.querySelector('.js-product-slider-main')
    var thumbnail = slider.querySelector('.js-product-slider-thumbnail')
  
    function setSwiper(slideContainer) {
      slideContainer.classList.add('swiper-container')
      var slideWrapper = slideContainer.querySelector('.js-product-slider-wrapper')
      slideWrapper.classList.add('swiper-wrapper')
      var slide = slideWrapper.querySelectorAll('.js-product-slider-slide')
      for (var i = 0; i < slide.length; i++) {
        slide[i].classList.add('swiper-slide')
      }
    }
  
    setSwiper(main)
    setSwiper(thumbnail)
  
    var galleryThumbs = new Swiper('.js-product-slider-thumbnail', {
      slidesPerView: 'auto',
      watchOverflow: true,
      on: {
        imagesReady: setPos,
        resize: setPos
      }
    })
  
    swiper= new Swiper('.js-product-slider-main', {
      speed: 300,
      effect: 'fade',
      allowTouchMove: false,
      thumbs: {
        swiper: galleryThumbs
      }
    })
  
    function setPos() {
      var wrapper = thumbnail.querySelector('.swiper-wrapper')
      if(thumbnail.scrollWidth > thumbnail.clientWidth) {
        wrapper.classList.remove('is-center')
      } else {
        wrapper.classList.add('is-center')
      }
    }
  }

  selectFunc()

  function selectFunc() {
    var selectContainer = document.querySelector('.js-product-select')
    if(!selectContainer) return false

    var currentWidth;
    window.addEventListener('resize', selectInit)
    selectInit()

    var currentWidth

    function selectInit() {
      if (currentWidth == window.innerWidth) {
        return
      }

      if (currentWidth != window.innerWidth) {
        if(window.innerWidth >= 1200) {
          setSelect()
          setSelectCount()
          window.removeEventListener('resize', selectInit)
        } else {
          currentWidth = window.innerWidth;
        }
      }
      
      currentWidth = window.innerWidth
    }
    
    // セレクト要素をコピーしてリスト要素に変換し選択したリストをセレクト要素に反映
    function setSelect() {
      var select = selectContainer.querySelector('select')
      selectContainer.insertAdjacentHTML('afterbegin','<div class="container"><ul class="list"></ul></div>')
      var container = selectContainer.querySelector('.container')
      var listContainer = container.querySelector('ul')
      var options = select.querySelectorAll('option')
      for (var i = 0; i < options.length; i++) {
        listContainer.insertAdjacentHTML('beforeend','<li><span>' + options[i].label + '</span></li>')
      }
      selectContainer.insertAdjacentHTML('afterbegin','<span class="text">' + select.options[select.selectedIndex].label + '</span>')
      var selectText = selectContainer.querySelector('span')
      
      selectText.addEventListener('click', showList )

      function showList(e) {
        e.stopPropagation()
        container.style.height = container.scrollHeight + 'px'
        selectText.removeEventListener('click', showList )
        document.addEventListener('click', hideList )
      }
  
      function hideList(e) {
        e.preventDefault()
        document.removeEventListener('click', hideList )
        selectText.addEventListener('click', showList )
        container.style.height = ''
      }

      selectText.style.minWidth = select.scrollWidth + 'px'

      if(window.document.body.style.visibility != 'visible') {
        var observer = new MutationObserver(checkBodyVisible);
        observer.observe(window.document.body, {attributes: true});
      }

      function checkBodyVisible() {
        if(window.document.body.style.visibility == 'visible') {
          observer.disconnect();
          selectText.style.minWidth = select.scrollWidth + 'px'
        }
      }
  
      var list = listContainer.querySelectorAll('li')
      for (var i = 0; i < list.length; i++) {
        list[i].addEventListener('click', listClick)
      }
      setSelectList()
  
      var listArray = [].slice.call( list ) ;

      var changeEvent
      try {
        changeEvent = new Event('change')
      } catch (error) {
        var changeEvent = document.createEvent('Event')
        changeEvent.initEvent('change', false, true)
      }
      function listClick(e) {
        e.preventDefault()
        list[select.selectedIndex].classList.remove('is-selected')
        select.selectedIndex = listArray.indexOf(e.target)
        select.dispatchEvent(changeEvent)
        selectText.innerText = select.options[select.selectedIndex].label
        setSelectList()
      }
  
      function setSelectList() {
        list[select.selectedIndex].classList.add('is-selected')
      }
  
      window.addEventListener('resize', resetSelect)
  
      function resetSelect() {
        if(window.innerWidth < 1200) {
          window.removeEventListener('resize', resetSelect)
  
          selectText.removeEventListener('click', showList )
          document.removeEventListener('click', hideList )
          for (var i = 0; i < list.length; i++) {
            list[i].removeEventListener('click', listClick)
          }
  
          container.parentNode.removeChild(container)
          selectText.parentNode.removeChild(selectText)
  
          window.addEventListener('resize', checkSelect)
        }
      }
  
      function checkSelect() {
        if(window.innerWidth >= 1200) {
          window.removeEventListener('resize', checkSelect)
          setSelect()
          window.addEventListener('resize', resetSelect)
        }
      }
    }
  
    // セレクト要素をカウントアップダウン
    function setSelectCount() {
      var selectCount = document.querySelector('.js-product-select-count')
      var select = selectCount.querySelector('select')
      selectCount.insertAdjacentHTML('afterbegin','<span class="down"></span>')
      selectCount.insertAdjacentHTML('afterbegin','<span class="up"></span>')
      selectCount.insertAdjacentHTML('afterbegin','<span class="text">' + select.options[select.selectedIndex].label + '</span>')
      var selectText = selectCount.querySelector('span')

      selectText.style.minWidth = select.scrollWidth + 'px'

      if(window.document.body.style.visibility != 'visible') {
        var observer = new MutationObserver(checkBodyVisible);
        observer.observe(window.document.body, {attributes: true});
      }

      function checkBodyVisible() {
        if(window.document.body.style.visibility == 'visible') {
          observer.disconnect();
          selectText.style.minWidth = select.scrollWidth + 'px'
        }
      }
  
      var down = selectCount.querySelector('.down')
      var up = selectCount.querySelector('.up')
  
      up.addEventListener('click', countUp)
      down.addEventListener('click', countDown)

      var changeEvent
      try {
        changeEvent = new Event('change')
      } catch (error) {
        var changeEvent = document.createEvent('Event')
        changeEvent.initEvent('change', false, true)
      }
  
      function countUp() {
        if(select.selectedIndex < select.length-1) {
          select.selectedIndex++
          select.dispatchEvent(changeEvent)
          selectText.innerText = select.options[select.selectedIndex].label
        }
      }
  
      function countDown() {
        if(select.selectedIndex > 0) {
          select.selectedIndex--
          select.dispatchEvent(changeEvent)
          selectText.innerText = select.options[select.selectedIndex].label
        }
      }
  
      window.addEventListener('resize', resetSelect)
  
      function resetSelect() {
        if(window.innerWidth < 1200) {
          window.removeEventListener('resize', resetSelect)
  
          up.removeEventListener('click', countUp)
          down.removeEventListener('click', countDown)
  
          down.parentNode.removeChild(down)
          up.parentNode.removeChild(up)
          selectText.parentNode.removeChild(selectText)
  
          window.addEventListener('resize', checkSelect)
        }
      }
  
      function checkSelect() {
        if(window.innerWidth >= 1200) {
          window.removeEventListener('resize', checkSelect)
          setSelectCount()
          window.addEventListener('resize', resetSelect)
        }
      }
  
    }
  }

  const products  = document.querySelector('.js-products')
  const category  = document.querySelectorAll('.js-main-category')
  const ageForm  = document.querySelector('.js-products-age')
  const cookies = document.cookie.split(';')
  let isConfirm
  cookies.forEach(function(value) {
    const content = value.split('=')
    if(content[0]=='age_confirmed') {
      isConfirm=content[1]
    }
  })
  if(!isConfirm) {
    products.style.pointerEvents = 'none'
    ageForm.style.display='block'
    category.forEach(function(target) {
      target.style.pointerEvents = 'none'
    })
  }

  ageForm.addEventListener('submit', setForm)
  function setForm(e) {
    e.preventDefault();
    const data = new FormData(e.target)
    const age = data.get('age')
    if (age >= 20) {
      document.cookie = "age_confirmed=true"
      ageForm.style.display='none'
      products.style.pointerEvents = ''
      category.forEach(function(target) {
        target.style.pointerEvents = ''
      })
    } else {
      location.href = '/';
    }
  }


  const ageFormBack = ageForm.querySelector('.js-products-age-back')
  const ref = document.referrer
  const re = new RegExp(location.hostname,'i')
  let isMatch = ref.match(re) ? true : false
  ageFormBack.addEventListener('click', function(e){
    e.preventDefault()
    if(isMatch) {
      history.back()
      setTimeout(function(){
        location.href = ageFormBack.getAttribute('href')
      },100)
    } else {
      location.href = ageFormBack.getAttribute('href')
    }
  })

  

}());